import { useQuery } from "@tanstack/react-query";
import api from "../services/api";

export const useSystemVersion = () => {
  const { data } = useQuery({
    queryKey: ["systemVersion"],
    queryFn: () => api.getSystemVersion()
  });

  const {
    data: {
      version = "",
      build_version: buildVersion = "",
      short_version: shortVersion = "",
      ticore_version_with_rc_build: ticoreVersion = ""
    } = {}
  } = data || {};

  return { version, buildVersion, shortVersion, ticoreVersion };
};
